import { action, observable, makeObservable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { FulfillmentOrderStore } from 'modules/order/stores';
import { CarrierServiceStore } from 'modules/carrier/stores';
import { ShipmentInfoStore } from 'modules/shipment-info/stores';
import { ExportLabelsForm } from 'modules/order/forms';
import { carrierServices } from 'common/constants';
import { notificationError } from 'core/utils';
import { createFileUrl } from 'core/utils';
import moment from 'moment';
import * as printJS from 'print-js';
import _ from 'lodash';

class ExportLabelsViewStore extends BaseViewStore {
	@observable selectedCarrierService = null;
	form = new ExportLabelsForm();

	constructor(rootStore) {
		super(rootStore);
		makeObservable(this);
		this.parentView = rootStore.orderListViewStore;
		this.fulfillmentOrderStore = new FulfillmentOrderStore(this.rootStore);
		this.carrierServiceStore = new CarrierServiceStore(this.rootStore);
		this.shipmentInfoStore = new ShipmentInfoStore(this.rootStore);
		this.form.state.options.set({
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		});
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();

		await this.carrierServiceStore.findCarrierService({ rpp: 30, page: 1 });
		const filteredArray = _.filter(this.carrierServiceStore.data, item => {
			return carrierServices.indexOf(item.name) > -1;
		});
		this.carrierServiceOptions = _.map(filteredArray, item => {
			if (item.name === 'USPS Priority Mail Express') {
				item.name = 'Stamps Express';
			}
			if (item.name === 'USPS First Class Mail') {
				item.name = 'Stamps Ground';
			}
			return { value: item.id, label: item.name, extra: item };
		});
		this.resume();
	};

	@action.bound
	onCarrierServiceSelect = carrierService => {
		if (carrierService && carrierService.value) {
			this.selectedCarrierService = carrierService;
			this.form.$('carrierService').invalidate();
			this.isSubmitted = false;
		}
	};

	@action.bound
	exportLabels = async () => {
		try {
			const userDateTime = moment().format();
			const response = await this.shipmentInfoStore.exportLabels(this.selectedCarrierService.value, userDateTime);
			if (response.data != null) {
				const fileURL = createFileUrl(response.data);
				printJS(fileURL);
				this.parentView.exportLabelsModal.close();
			} else {
				this.rootStore.notificationStore.error('FULFILLMENTORDERVIEW.NOLABELSTOEXPORT');
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
	};
}

export default ExportLabelsViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/ExportLabelsViewStore.js